/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

const jsonData = {
  "squareup": {
    "nested": {
      "regulator": {
        "nested": {
          "action": {
            "nested": {
              "v1": {
                "nested": {
                  "ActionInputOptions": {
                    "fields": {
                      "label": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "hidden": {
                        "type": "bool",
                        "id": 2,
                        "rule": "optional"
                      },
                      "description": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.regulator?.nested?.action?.nested?.v1?.nested?.ActionInputOptions) {
	$root.addJSON(jsonData);
}

/**
 * SOURCE ActionInputOptions @ squareup/regulator/action/v1/input_field_options.proto at 17:1
 */
export const ActionInputOptions = $root.lookupType('squareup.regulator.action.v1.ActionInputOptions');
fixType(ActionInputOptions);
Builder.createAndAttachToType(ActionInputOptions);
